/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Formula_NoteInputs */

const tr_katalog_desi_page_formula_note = /** @type {(inputs: Katalog_Desi_Page_Formula_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm ölçüler santimetre (cm) cinsindendir. Yurtiçi gönderilerde bölen 3000'dür (uluslararası kargoda genelde 5000).`)
};

const en_katalog_desi_page_formula_note = /** @type {(inputs: Katalog_Desi_Page_Formula_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All dimensions are in centimetres (cm). For domestic shipments the divisor is 3000 (international cargo usually 5000).`)
};

const de_katalog_desi_page_formula_note = /** @type {(inputs: Katalog_Desi_Page_Formula_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Maße sind in Zentimetern (cm). Für Inlandssendungen ist der Teiler 3000 (internationale Fracht meist 5000).`)
};

const ru_katalog_desi_page_formula_note = /** @type {(inputs: Katalog_Desi_Page_Formula_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все размеры в сантиметрах (см). Для внутренних отправлений делитель 3000 (для международных обычно 5000).`)
};

/**
* | output |
* | --- |
* | "All dimensions are in centimetres (cm). For domestic shipments the divisor is 3000 (international cargo usually 5000)." |
*
* @param {Katalog_Desi_Page_Formula_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_formula_note = /** @type {((inputs?: Katalog_Desi_Page_Formula_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Formula_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_formula_note(inputs)
	if (locale === "de") return de_katalog_desi_page_formula_note(inputs)
	if (locale === "ru") return ru_katalog_desi_page_formula_note(inputs)
	return tr_katalog_desi_page_formula_note(inputs)
});